var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-horizontal"},[_c('form-input',{attrs:{"form":_vm.form,"property":"name"}}),_vm._v(" "),(_vm.exists)?_c('activity-log',{ref:"activityLog",attrs:{"api":("/api/integrations/tags/" + (_vm.form.id) + "/activity")}}):_vm._e()],1)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae8a1d28","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/forms/integrations/Tag.vue
// module id = 65/A
// module chunks = 0 1 2